import {Text, View} from '@react-pdf/renderer';

import {sharedStyles} from './styles/shared-styles';

interface Props {
  applicantName: string;
  jobPosting: string;
}

export const ReportHeader = ({applicantName, jobPosting}: Props) => {
  return (
    <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
      <Text style={{...sharedStyles.h1, marginRight: 10}}>{applicantName}</Text>
      <Text style={{...sharedStyles.h4, marginBottom: 4}}>{jobPosting}</Text>
    </View>
  );
};
